import { render, staticRenderFns } from "./FaqBlock.vue?vue&type=template&id=1732f0ba&"
import script from "./FaqBlock.vue?vue&type=script&lang=js&"
export * from "./FaqBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports